export default "__VITE_ASSET__fa660569__"